'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'duck';
var width = 512;
var height = 512;
var aliases = [129414];
var unicode = 'f6d8';
var svgPathData = 'M431.5 125.9c-5.1-52.7-49.5-93.9-103.5-93.9-57.4 0-104 46.6-104 104 0 36.8 19.1 69.2 48 87.7l0 4.9-208 59.4-32-32-32 0 0 32C0 394 86 480 192 480l120 0c70.7 0 128-57.3 128-128 0-36.6-15.4-69.6-40-93l0-35 16 0c53 0 96-43 96-96l-64 0-16.5-2.1zM320 136a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM242.1 396.4c-32.8 8.2-65.9-.7-89.2-21.4 8.9-10 17.7-19.9 26.6-29.9 13.4 11.9 33.1 17.4 52.9 12.5 24.3-6.1 40.9-25.7 43.8-47.3l39.6 5.3c-5.1 38.2-33.7 70.9-73.7 80.9z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDuck = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;